/**
 *
 * TestTypeDetails
 *
 */

import React, { memo, FunctionComponent, useState } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  ComponentDialogBody,
  StyledDialogActionsBar,
  StyledModalAction,
} from '../../../../components/DiaogWrap/styles';
import { Column, Row, Wrap } from '../../../../assets/styledAssets/grid';
import {
  StyledFormField,
  StyledLabel,
} from '../../../../components/FormField/styles';
import { Input } from '@progress/kendo-react-inputs';

interface IProps {
  onCancel: () => void;
  onSave: (name: string) => void;
  testTypeName?: string;
}

const TestTypeDetails: FunctionComponent<IProps> = ({ onCancel, onSave, testTypeName}) => {
  const intl = useIntl();
  const [name, setName] = useState<string>(testTypeName || '');
  return (
    <>
      <ComponentDialogBody>
        <Row>
          <Wrap margin={'0 0 3rem'} width={'100%'}>
            <Column xs={100} md={100}>
              <StyledLabel>{intl.formatMessage(messages.name)}</StyledLabel>
              <StyledFormField>
                <Input onChange={(e) => setName(e.value)} value={name} />
              </StyledFormField>
            </Column>
          </Wrap>
        </Row>
      </ComponentDialogBody>
      <StyledDialogActionsBar>
        <StyledModalAction onClick={onCancel}>
          {intl.formatMessage(messages.cancel)}
        </StyledModalAction>
        <StyledModalAction accent onClick={() => onSave(name)}>
          {intl.formatMessage(messages.save)}
        </StyledModalAction>
      </StyledDialogActionsBar>
    </>
  );
};

export default memo(TestTypeDetails);
